<template src="./SensorLanding.html"></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers("sensor");
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";
// import vendorService from "@/api/vendorService";
// const apiMethods = require("./../../../../api/api")
import DialogBox from "@/components/DialogBox";
import ViewDropdown from "@/components/ViewDropdown";
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";
import moment from "moment-timezone";
// import Address from "@/views/Driver/Address";
import AddressCell from "@/components/AddressCell";
import EmployeeErrors from "@/components/EmployeeError";
export default {
  
  components: {
    DialogBox,
    ViewDropdown,
    AddressCell,
    EmployeeErrors
  },
  data: function() {
    return {
      title: null,
      temp: {address: "sfwnrfwjnfjwf fwefnwjenfwefnwenf fwenf"},
      gridHeight: window.innerHeight - 120,
      // addoredit: false,
      gridData: [],
      searchText:"",
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      add: true,
      sort: [{ field: "name", dir: "asc" }],
      filteredColumns: [],
      columns: [
        { hidden: false, field: "name", title: "Name", checked: true, defaultSelected: true, },
        // { hidden: false, field: "purchaseDate", title: "Purchase Date", width: "80px",checked: true, defaultSelected: true, },
        { hidden: false, cell: CommandCell, locked: true, title: "Actions", width: "160px", ignoreCheckbox: true, },
      ],
      dataItems: [],
    };
  },
  methods: {
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    showErrors: function() {
      this.$refs.rosterErros.show();
    },
     uploadTemplate(e) {
      this.$store.dispatch("driver/uploadTemplate", e);
      this.$refs.templateUpload.value = "";
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function() {
      this.add = true;
    },
    goToAddPage: function() {
      this.$router.push({ name: "sensorAddUpdate", params: { add: true } });
    },
    remove: function(item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
    OkMethod() {
      let item = this.dataItems;
      return this.$store
        .dispatch("sensor/deleteSensor", item)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
        })
        .catch(notifyApiError);
    },
    edit: function(item) {
      return this.$store.dispatch("sensor/editSensor", item.dataItem); //item.dataItem.id
    },
    columnChange: function (e) {
      if (e.item.checked) {
        e.item.hidden = false;
      } else {
        e.item.hidden = true;
      }
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.DRIVER_MANAGEMENT, 
        JSON.stringify(this.filteredColumns)
      );
    },
        exportExcel(){
        saveExcel({
        data:  this.driverList,
        fileName: "driver",
        columns:this.columns
      });
    },
    downloadTemplate(){

      this.$store.dispatch("driver/DownloadTemp");
      //    saveExcel({
      //   data:  [],
      //   fileName: "driverTemplate",
      //   columns:this.columns
      // });
    },
    getDate: function(h, tdElement, props) {
      let date = props.dataItem[props.field];
      if (date) {
        if (date.charAt(date.length - 1) === 'Z') {
          date = moment(date).format("MM/DD/YYYY");
        } else {
          date = moment(date + 'Z').format("MM/DD/YYYY");
        }
      }
      return h("td", {}, date ? date.toString() : "");
    },
    getVendorInfo: function(h, tdElement, props) {
      let vendorId = props.dataItem[props.field];
      const vendor = this.vendors.find((v) => v.id === vendorId);
      return h("td", {}, vendor ? vendor.name : '');
    },
  },
  computed: {
    ...mapState(['devices', 'loader', "EmployeeErrors"]),
    ...mapGetters(["getSensors"]),
    total() {
      return this.getSensors ? this.getSensors.length : 0;
    },
    items: {
      get: function() {
        return orderBy(
          this.sensorListVal.slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
   sensorListVal() {
     return this.getSensors.filter((data) => data.name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1);
   },
  },
  created: function() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type == "setSeclectedFacility") {
        // this.loadVendor();
        // this.getDataOnload();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  beforeMount() {
    const eListColumns = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEYS.DRIVER_MANAGEMENT)
    );
    if (!eListColumns) {
      this.filteredColumns = this.columns;
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find(c => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,           
              hidden: obj.hidden,
              checked: obj.checked,
            });
          } else {
            items.push({...col});
          }
      });
      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.filteredColumns = items;
    }
  }
};
</script>

<style lang="scss" scoped>
  .search_mobile{width: 15% !important; border-radius: 5px;}
  @media only screen and (max-width: 768px) {
  .search_mobile{width: 40% !important;}
  .mobile_hide_show{display: none;}
  .driver_header_mobile{flex-direction: row !important; padding: 10px 10px 10px 10px;}
  .page-header .title-text {font-size: 12px;} 
  }
</style>
